// extracted by mini-css-extract-plugin
export default {"staticBanner":"StaticBanner-staticBanner-gav","red":"StaticBanner-red-EoV"};